import { emitHealthFinding, } from "@openmeld/agent-runtime";
export const emitRuntimeHealthFinding = (input) => {
    emitHealthFinding({
        eventName: input.eventName,
        fields: input.fields,
        finding: input.finding,
    });
};
